<template>
  <div>
    <div class="flex items-center p-2 border-b">
      <div class="mr-4 w-5 h-5">
        <font-awesome-icon class="text-xl" :icon="['fad', 'user-circle']" />
      </div>
      <div class="min-w-0">
        <div class="font-medium truncate">
          {{ user.idTokenParsed.given_name }}
          {{ user.idTokenParsed.family_name }}
        </div>
        <div class="text-sm text-gray-700 truncate">{{ user.idTokenParsed.preferred_username }}</div>
      </div>
    </div>

    <div class="border-b">
      <a
        v-for="account in accounts"
        :key="account.id"
        :href="`/${account.id}`"
        class="flex items-center p-2 hover:bg-gray-100"
      >
        <div
          class="mr-4 w-5 flex-shrink-0 uppercase flex justify-center items-center bg-gray-800 rounded text-white text-sm font-medium"
        >{{ account.company_name.charAt(0) }}</div>
        <div class="min-w-0">
          <div class="truncate">{{ account.company_name }}</div>
        </div>
      </a>
    </div>

    <a :href="user.createAccountUrl()" class="flex items-center p-2 hover:bg-gray-100">
      <div class="w-5 mr-4 text-center">
        <font-awesome-icon :icon="['fad', 'user']" />
      </div>
      <div class="min-w-0">
        <div class="text-sm truncate">Kontoeinstellungen</div>
      </div>
    </a>

    <a :href="user.createLogoutUrl()" class="flex items-center p-2 hover:bg-gray-100">
      <div class="w-5 mr-4 text-center">
        <font-awesome-icon :icon="['fad', 'sign-out']" />
      </div>
      <div class="min-w-0">
        <div class="text-sm truncate">Ausloggen</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: ["accounts", "user"]
};
</script>